import { createContext, useContext } from 'react';

import { DEFAULT_TIME_COMMITMENT } from 'bundles/adaptive-learning-common/constants';
import type { AdaptiveLearningPlan, LearningBlock, TimeCommitment } from 'bundles/adaptive-learning-common/types';

export type AdaptiveLearningContextType = {
  isEnabled: boolean;
  show: boolean;
  loading: boolean;
  setShow: (show: boolean) => void;
  adaptivePlan?: AdaptiveLearningPlan;
  timeCommitment: TimeCommitment;
  planUpdated: boolean;
  getLearningBlock: (itemId: string) => LearningBlock | undefined;
  regeneratePlan: (timeCommitment: TimeCommitment) => Promise<void>;
  refetchPlan: () => Promise<void>;
  isProgressDialogOpen: boolean;
  setIsProgressDialogOpen: (open: boolean) => void;
  isNonPersonalizedLoadingDialogOpen: boolean;
  setIsNonPersonalizedLoadingDialogOpen: (open: boolean) => void;
};

export const AdaptiveLearningContext = createContext<AdaptiveLearningContextType>({
  isEnabled: false,
  show: false,
  loading: false,
  planUpdated: false,
  setShow: () => undefined,
  timeCommitment: DEFAULT_TIME_COMMITMENT,
  getLearningBlock: () => undefined,
  regeneratePlan: () => Promise.resolve(),
  isProgressDialogOpen: false,
  setIsProgressDialogOpen: () => undefined,
  refetchPlan: () => Promise.resolve(),
  isNonPersonalizedLoadingDialogOpen: false,
  setIsNonPersonalizedLoadingDialogOpen: () => undefined,
});

export const useAdaptiveLearningContext = () => useContext(AdaptiveLearningContext);
